import { render, staticRenderFns } from "./VuseSectionDefinition.vue?vue&type=template&id=400c501b&scoped=true&"
import script from "./VuseSectionDefinition.vue?vue&type=script&lang=js&"
export * from "./VuseSectionDefinition.vue?vue&type=script&lang=js&"
import style0 from "./VuseSectionDefinition.vue?vue&type=style&index=0&id=400c501b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400c501b",
  null
  
)

export default component.exports